import Alpine from 'alpinejs';

Alpine.data('cart', () => ({
  working: false,

  events: {
    ['x-on:cart:changing.window']() {
      this.working = true
    },
    ['x-on:cart:refreshing.window']() {
      this.working = true;
    },
    ['x-on:cart:refreshed.window']() {
      this.working = false;
    }
  },

  get cart() {
    return this.$store.cart;
  },

  get isEmpty() {
    return this.cart.items.length === 0;
  },

  async decrement(item) {
    await Shopify.cart.change(item.key, item.quantity - 1);
  },

  async increment(item) {
    await Shopify.cart.change(item.key, item.quantity + 1).catch((error) => {
      this.$dispatch('toast:show', {
        message: error.message,
        timeout: 2000,
        type: 'error',
      }, true);
    });
  },

  async updateQuantity(item, event) {
    let value = parseInt(event.target.value);

    if (isNaN(value)) {
      event.target.value = item.quantity;
    }

    await Shopify.cart.change(item.key, value);
  },
}));